import { Quill } from 'react-quill';
import { get } from 'lodash';

const Parchment = Quill.import('parchment');

class CustomColor extends Parchment.Attributor.Style {
  value(node) {
    let value = super.value(node);

    if (!value.startsWith('rgb(')) return value;

    value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
    return `#${value.split(',').map(component => (`00${parseInt(component, 10).toString(16)}`).slice(-2)).join('')}`;
  }
}
export const customColorAttributor = new CustomColor('custom-color', 'color', {
  scope: Parchment.Scope.BLOCK,
});

export const customFontSizeAttributor = new Parchment.Attributor.Style('custom-font-size', 'font-size', {
  scope: Parchment.Scope.BLOCK,
});

export const normalFontSizeAttributor = new Parchment.Attributor.Style('size', 'font-size', {
  scope: Parchment.Scope.INLINE,
});

const ListItemBlot = Quill.import('formats/list/item');

export class CustomListItem extends ListItemBlot {
  optimize(context) {
    super.optimize(context);
    if (this.children.length >= 1) {
      // eslint-disable-next-line prefer-destructuring
      const head = this.children.head;
      // eslint-disable-next-line prefer-destructuring
      const attributes = head.attributes;

      if (attributes && attributes.attributes.color) {
        const color = attributes.attributes.color.value(head.domNode);
        super.format('custom-color', color);
        // eslint-disable-next-line no-prototype-builtins
      } else if (this.attributes.attributes.hasOwnProperty('custom-color')) {
        super.format('custom-color', null);
      }

      if (attributes && attributes.attributes.size) {
        const size = attributes.attributes.size.value(head.domNode);
        super.format('custom-font-size', size);
        // eslint-disable-next-line no-prototype-builtins
      } else if (this.attributes.attributes.hasOwnProperty('custom-font-size')) {
        super.format('custom-font-size', null);
      }

      this.children.forEach((element) => {
        if (element !== head && get(element, 'attributes.attributes.color')) {
          element.format('color', null);
        }
        if (element !== head && get(element, 'attributes.attributes.size')) {
          element.format('size', null);
        }
      });
    }
  }
}
